/**
 * @description: Request result set
 */
export enum ResultEnum {
	SUCCESS = 0,
	ERROR = -1,
	TIMEOUT = 401,
	TYPE = 'success',
}

/**
 * @description:  contentType
 */
export enum ContentTypeEnum {
	// json
	JSON = 'application/json;charset=UTF-8',
	// form-data qs
	FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
	// form-data  upload
	FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

export const STATUS_CODE_MESSAGE = readonly({
	200: '服务器成功返回请求的数据。',
	201: '新建或修改数据成功。',
	202: '一个请求已经进入后台排队（异步任务）。',
	204: '删除数据成功。',
	400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
	401: '登录失效。',
	403: '没有进行该操作的权限。',
	405: '请求方法不允许。',
	406: '请求的格式不可得。',
	410: '请求的资源被永久删除，且不会再得到的。',
	422: '当创建一个对象时，发生一个验证错误。',
	500: '服务器内部错误。',
	502: '服务不可用，服务器暂时过载或维护。',
	503: '服务不可用，服务器暂时过载或维护。',
	504: '网关超时。',
})
